import forCompanies from "../../../assets/for-companies.svg";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useState } from "react";

const faqs = [
  {
    id: "panel1",
    question: "How Does Billing Work?",
    answer:
      "We commonly have JavaScript, Python, RoR, Data Science, Java, and Swift on tap. But go ahead and let us know what particular stack you are looking for",
  },
  {
    id: "panel2",
    question: "When I will be charged?",
    answer:
      "We commonly have JavaScript, Python, RoR, Data Science, Java, and Swift on tap. But go ahead and let us know what particular stack you are looking for",
  },
  {
    id: "panel3",
    question:
      "How can I cover outstanding hours if the developer works extra hours?",
    answer:
      "We commonly have JavaScript, Python, RoR, Data Science, Java, and Swift on tap. But go ahead and let us know what particular stack you are looking for",
  },
  {
    id: "panel4",
    question: "Do I collect extra hours?",
    answer:
      "We commonly have JavaScript, Python, RoR, Data Science, Java, and Swift on tap. But go ahead and let us know what particular stack you are looking for",
  },
  {
    id: "panel5",
    question: "What happens to my balance after the project is finished?",
    answer:
      "We commonly have JavaScript, Python, RoR, Data Science, Java, and Swift on tap. But go ahead and let us know what particular stack you are looking for",
  },
  {
    id: "panel6",
    question: "What payment options do you have?",
    answer:
      "We commonly have JavaScript, Python, RoR, Data Science, Java, and Swift on tap. But go ahead and let us know what particular stack you are looking for",
  },
  {
    id: "panel7",
    question: "How Does Billing Work?",
    answer:
      "We commonly have JavaScript, Python, RoR, Data Science, Java, and Swift on tap. But go ahead and let us know what particular stack you are looking for",
  },
];

export default function ForCompaniesFaq() {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <>
      <div className="for-companies-wrapper">
        <div className="faq-heading-icon-wrapper d-flex-essy items-center-essy">
          <img src={forCompanies} alt="for-companies" />
          <h3>For Companies</h3>
        </div>
        {faqs.map((faq) => (
          <Accordion
            key={faq.id}
            expanded={expanded === faq.id}
            onChange={handleChange(faq.id)}
          >
            <AccordionSummary
              expandIcon={expanded === faq.id ? <RemoveIcon /> : <AddIcon />}
              aria-controls={`${faq.id}-content`}
              id={`${faq.id}-header`}
            >
              <Typography>{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </>
  );
}
